import React from 'react'

const Home = () => {
  return (
    <div>
      <h1 className='text-center text-3xl font-bold py-8'>TODOZ a todo-list interview project by Shaikh Mohammed Zaid</h1>
    </div>
  )
}

export default Home